/**
 * Cycle color palette used across the application.
 * 
 * Exported for use in both canvas visualizations (useSimpleCycleConnector)
 * and translation panel rendering (CycleBracket).
 * 
 * Cycles are colored by order (first cycle = indigo, second = pink, etc.)
 * to provide visual distinction on both the graph and protocol views.
 */

export const CYCLE_COLORS = [
  '#6366F1', // indigo
  '#EC4899', // pink
  '#F59E0B', // amber
  '#10B981', // emerald
  '#8B5CF6', // violet
];

/**
 * Get the color for a cycle at a given index.
 * Wraps around if more cycles than colors (rare).
 */
export function getCycleColor(cycleIndex: number): string {
  return CYCLE_COLORS[cycleIndex % CYCLE_COLORS.length];
}
